import { isEmpty } from 'lodash-es';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { useScopedAppFlagStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { useLocalStorage } from '@frontend/web-storage';

const LOCALSTORAGE_KEYS = {
  WAITLIST_FF_OVERRIDE: 'weave.schedule-waitlist-ff-override',
  DIRECT_SCHEDULING_FF_OVERRIDE: 'weave.schedule-waitlist-direct-scheduling-ff-override',
};
const WAITLIST_FF_NAME = 'schedule:waitlist';
const DIRECT_SCHEDULING_FF_NAME = 'schedule:waitlist:direct_scheduling';

const useFFOverride = () => {
  const [isWaitlistFFOverride] = useLocalStorage({
    key: LOCALSTORAGE_KEYS.WAITLIST_FF_OVERRIDE,
    // Note: need to keep it like this as for initial cases, we receive false even if value is set to true
    defaultValue: localStorage.getItem(LOCALSTORAGE_KEYS.WAITLIST_FF_OVERRIDE) === 'true',
  });
  const [isDirectSchedulingFFOverride] = useLocalStorage({
    key: LOCALSTORAGE_KEYS.DIRECT_SCHEDULING_FF_OVERRIDE,
    // Note: need to keep it like this as for initial cases, we receive false even if value is set to true
    defaultValue: localStorage.getItem(LOCALSTORAGE_KEYS.DIRECT_SCHEDULING_FF_OVERRIDE) === 'true',
  });

  return { isOverrideWaitlistFF: !!isWaitlistFFOverride, isOverrideDirectSchedulingFF: !!isDirectSchedulingFFOverride };
};

export const useGetWaitlistFeatureFlagDetails = () => {
  const { isOverrideWaitlistFF, isOverrideDirectSchedulingFF } = useFFOverride();
  const { featureFlags } = useAppFlagStore();
  const isFeatureFlagsLoaded = !isEmpty(featureFlags);

  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  // NOTE: Remove this temporary check(isFeatureFlagsLoaded) later once this logic added into `getFeatureFlagValue` method
  const hasWaitlistFF = isFeatureFlagsLoaded && getFeatureFlagValue(WAITLIST_FF_NAME, 'ALL');
  const hasDirectSchedulingFF = isFeatureFlagsLoaded && getFeatureFlagValue(DIRECT_SCHEDULING_FF_NAME, 'ALL');
  const isLoading = !isFeatureFlagsLoaded || isLoadingIntegrationDetails;

  const isWaitlistFFEnabled = (!isLoading && hasWaitlistFF) || isOverrideWaitlistFF;
  const isDirectSchedulingFFEnabled = (!isLoading && hasDirectSchedulingFF) || isOverrideDirectSchedulingFF;

  const isWaitlistDirectBookingEnabled = isWaitlistFFEnabled && isDirectSchedulingFFEnabled && !isIntegratedOffice;

  return {
    isLoading,
    isWaitlistFFEnabled,
    isWaitlistDirectBookingEnabled,
  };
};
